import { render, staticRenderFns } from "./allotUser.vue?vue&type=template&id=16e69cca"
import script from "./allotUser.vue?vue&type=script&lang=js"
export * from "./allotUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16e69cca')) {
      api.createRecord('16e69cca', component.options)
    } else {
      api.reload('16e69cca', component.options)
    }
    module.hot.accept("./allotUser.vue?vue&type=template&id=16e69cca", function () {
      api.rerender('16e69cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/role/allotUser.vue"
export default component.exports